import React, { memo } from 'react'
import { Skeleton } from '@mui/material'
import Grid from '@mui/material/Grid2'
import MainBanner from 'components/shared/MainBanner'
import Page from 'components/layout/Page'
// import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import useUtms from 'hooks/useUtms'
import BannerImage from 'public/img/how-to-buy/banner.png'
import { TESTIDS_HTB as TESTIDS } from 'testids'
import QuickLinks from 'components/HowToBuyPage/QuickLinks'
import TimelineAndVideo from 'components/shared/TimelineAndVideo'
import InternalSections from 'components/shared/InternalSection'
import usePageProps from 'hooks/usePageProps'
import ValueProposal from 'components/HowToBuyPage/ValueProposal'
import dynamic from 'next/dynamic'
import Makes from 'components/shared/Makes'
import GoogleReviewsAndPress from 'components/shared/GoogleReviewsAndPress'
import Faqs from 'components/FaqsPage/Faqs'
import HomeFeature1Icon from 'components/icons/home-feature1.svg'
import HomeFeature2Icon from 'components/icons/home-feature2.svg'
import HomeFeature3Icon from 'components/icons/home-feature3.svg'
import HomeFeature4Icon from 'components/icons/home-feature4.svg'
import HomeFeature5Icon from 'components/icons/home-feature5.svg'
import HomeFeature6Icon from 'components/icons/home-feature6.svg'
import Text, { TEXT_TYPES } from 'components/designSystem/Text'
import sx from './style'

const RatingComponent = dynamic(() => import('components/shared/Rating'), {
  loading: () => (
    <Skeleton
      variant="rectangular"
      animation="wave"
      height={160}
      width="100%"
    />
  ),
  ssr: false,
})

const VehicleTypesComponent = dynamic(
  () => import('components/shared/Swipers/VehicleTypes'),
  {
    loading: () => (
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={160}
        width="100%"
      />
    ),
    ssr: false,
  },
)
const HowToBuyCar = () => {
  const { formatMessage: f } = useIntl()
  const {
    internalSections, buyCarTimeline, makesSYC, htbFaqs,
  } = usePageProps()
  // const router = useRouter()
  const query = useUtms()
  const nextLink = f({ id: 'ROUTE_SEARCH' })
  // const redirectTo = () => router.push(`${nextLink}${query}`)
  const mainBanner = {
    title: f({ id: 'HTB_BANNER_TITLE' }),
    subtitle: f({ id: 'HTB_BANNER_DESCRIPTION' }),
    mainImage: {
      url: BannerImage,
      alt: f({ id: 'HTB_BANNER_TITLE' }),
    },
  }
  const items = [
    {
      icon: <HomeFeature6Icon />,
      line1: f({ id: 'BUY_AND_TEST' }),
      line2: f({ id: 'BUY_AND_TEST_DISCRIPTION' }),
      hidden: true,
    },
    {
      icon: <HomeFeature1Icon />,
      line1: f({ id: 'TOTAL_WARRANTY' }),
      line2: f({ id: 'TOTAL_WARRANTY_DESCRIPTION' }),
    },
    {
      icon: <HomeFeature2Icon />,
      line1: f({ id: 'WE_REVIEWED_ALL_POINTS' }),
      line2: f({ id: 'WE_REVIEWED_ALL_POINTS_DESCRIPTION' }),
    },
    {
      icon: <HomeFeature3Icon />,
      line1: f({ id: 'DOCUMENT_SECURITY' }),
      line2: f({ id: 'DOCUMENT_SECURITY_DESCRIPTION' }),
      hidden: true,
    },
    {
      icon: <HomeFeature5Icon />,
      line1: f({ id: 'BUY_WITH_CREDIT' }),
      line2: f({ id: 'BUY_WITH_CREDIT_DESCRIPTION' }),
      hidden: true,
    },
    {
      icon: <HomeFeature4Icon />,
      line1: f({ id: 'WITHOUT_LEAVING_HOUSE' }),
      line2: f({ id: 'WITHOUT_LEAVING_HOUSE_DESCRIPTION' }),
      hidden: true,
    },
  ]

  const faqSection = {
    button: {
      text: 'HTB_FAQS_TEXT_BUTTON',
      href: 'ROUTE_FAQS',
    },
  }

  return (
    <Page>
      <MainBanner {...mainBanner}>
        <>
          <QuickLinks
            testId={TESTIDS.HTB_QUICKLINKS}
            varaintTitle="h2"
            isOverflow={false}
            sxProps={sx.quickLinks}
          />
          <Text
            type={TEXT_TYPES.body.x2}
            mt={1}
            sx={sx.freeDeliveryText}
          >
            {f({ id: 'HTB_FREE_DELIVERY' })}
          </Text>
        </>
      </MainBanner>

      <TimelineAndVideo
        data={buyCarTimeline}
        tabs={internalSections[1]?.time_line[0].tabs}
      >
        <VehicleTypesComponent
          title={f({ id: 'FIND_THE_PERFECT_VEHICLE' })}
          testId={TESTIDS.HTB_QUICKLINKS}
          varaintTitle="h2"
          redirectToSRP
        />
      </TimelineAndVideo>
      <InternalSections
        data={internalSections?.slice(0, 2)}
        shoGoToHomeButton={false}
        testId={TESTIDS.HTB_INTERNAL_SECTIONS}
      />
      <Grid sx={sx.ratingComponent}>
        <Grid
          size={12}
          container
          sx={sx.container}
        >
          <Grid size={12}>
            <ValueProposal
              testId={TESTIDS.HTB_PROPOSALS}
              title="WE_INSPECT_VEHICLES"
              disclaimer="SECTION2_DISCLAIMER"
              items={items}
              mt={3}
            />
          </Grid>
          <Grid size={12}>
            <RatingComponent
              textVariant="h3"
              text={f({ id: 'HTB_GOOGLE_REVIEW_TEXT' })}
            />
          </Grid>
        </Grid>
        <Grid size={12}>
          <Makes
            makes={makesSYC}
            expanded
            variant="row"
            collapsable={false}
            title={f({ id: 'HTB_MAKES_TITLE' })}
            description={f({ id: 'HTB_ALL_CARS_HAVE_WARRANTIES' })}
            showButton
            buttonText="HTB_MAKES_TEXT_BUTTON"
            cardFormat
            buttonRedirect={`${nextLink}${query}`}
            variantRedirect="srp"
          />
        </Grid>
      </Grid>

      <InternalSections
        data={internalSections?.slice(2, 5)}
        shoGoToHomeButton={false}
        testId={TESTIDS.HTB_INTERNAL_SECTIONS}
      />

      <Faqs
        variant="row"
        data={htbFaqs}
        title="HTB_FAQS_TITLE"
        showContactUs
        faqSectionProps={faqSection}
        testId={TESTIDS.HTB_FAQS}
      />
      <GoogleReviewsAndPress
        variant="row"
        sx={sx.googleReviewsContainer}
        testId={TESTIDS.HTB_GOOGLE_REVIEWS}
      />
    </Page>
  )
}

export default memo(HowToBuyCar)
